import {
  KimIconDark,
  KimIconLight,
  KimLogoCollapsed,
  KimLogoCollapsedDark,
} from '../../Icons';
import { useThemeStore } from '../../state/theme';

interface LogoIconProps {
  collapsed?: boolean;
}

const LogoIcon = ({ collapsed = false }: LogoIconProps) => {
  const { isDarkMode } = useThemeStore();

  if (collapsed) {
    return (
      <span className="flex items-center w-full py-4 justify-center">
        {isDarkMode ? (
          <KimLogoCollapsedDark className="w-6 h-6" />
        ) : (
          <KimLogoCollapsed className="w-6 h-6" />
        )}
      </span>
    );
  }

  return isDarkMode ? (
    <KimIconDark className="w-16 ml-2 h-16" />
  ) : (
    <KimIconLight className="w-16 ml-2 h-16" />
  );
};

export default LogoIcon;
